import { render, staticRenderFns } from "./specNoConflict.vue?vue&type=template&id=67a70f04&scoped=true"
import script from "./specNoConflict.vue?vue&type=script&lang=js"
export * from "./specNoConflict.vue?vue&type=script&lang=js"
import style0 from "./specNoConflict.vue?vue&type=style&index=0&id=67a70f04&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a70f04",
  null
  
)

export default component.exports